import styled from "styled-components";
import { colors, device } from "../../../../utils";

const Wrapper
	= styled.li`

		@media ${device.tabletUp} {
			padding: calc(2px + .2vw) calc(6px + .6vw) calc(2px + .2vw) calc(30px + .8vw);
		}

		@media ${device.tabletDown} {
			padding: calc(2px + .2vw) calc(6px + .6vw);
		}

		display: flex;
		gap: calc(2px + .2vw);
		align-items: center;

		background-color: ${(props) => props.active ? colors.success : "transparent"};
		color: ${(props) => props.active ? "black" : "white"};
		margin-top: calc(2px + .2vw);
		text-transform: capitalize;
		border-radius: 2px;
		cursor: pointer;

		&:hover {
			background-color: ${(props) => props.active ? colors.success : "rgba(255,255,255,.1)"};;
		}

		.value {
			font-size: 95%;
		}
		.icon {
			color: ${(props) => props.active ? "black" : "white"};
			font-size: ${(props) => !props.active && "95%"};
		}

	`

export default Wrapper
